import cookie from 'cookie';
import {gladiatorService} from '@jobseeker/common-core/services';
import {COOKIE_LOGIN_AUTH} from '@jobseeker/common-core/constants';
import type {IncomingMessage} from 'http';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export async function getSearchBarVariant(context: {
  req?: IncomingMessage;
}): Promise<'pill' | 'control' | null> {
  if (!isAppIimjobs) return null;

  const experimentId = parseInt(
    process.env.NEXT_PUBLIC_SEARCH_BAR_EXPERIMENT_ID ?? '0',
    10
  );
  if (!experimentId) return null;

  try {
    const cookieHeader = context.req?.headers?.cookie;
    const abCookies = cookieHeader ? cookie.parse(cookieHeader) : {};
    const tDsCookie = abCookies?.['_t_ds'];

    if (!tDsCookie) return null;

    // Works for both logged-in and logged-out users: a session token is
    // resolved (and sent) only when a login cookie is present, mirroring
    // getMultiApplyVariant.ts. Exact auth requirement for anonymous users
    // TBD from backend — revisit once confirmed.
    let sessionToken: string | undefined;
    if (abCookies?.[COOKIE_LOGIN_AUTH]) {
      const validateInfo = await gladiatorService.validate('validate', {
        headers: {cookie: cookieHeader},
      });
      sessionToken = validateInfo?.token;
    }

    const abResponse = await fetch(
      `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_AB_TEST}/get-variant?experimentId=${experimentId}`,
      {
        method: 'GET',
        headers: {
          referer: `https://www.${process.env.NEXT_PUBLIC_APP_DOMAIN}/`,
          ...(sessionToken ? {Authorization: `Bearer ${sessionToken}`} : {}),
          cookie: `_t_ds=${tDsCookie}`,
          _t_ds: tDsCookie,
        },
      }
    );

    const abData = await abResponse.json();
    const variantName = abData?.data?.variant?.name;
    if (!variantName) return 'control';
    return variantName === 'control' ? 'control' : 'pill';
  } catch {
    return null;
  }
}
